import {removeGershaim} from './streets';

const hebrewCollator = new Intl.Collator('he');

export const buildCityOptions = (cityItems = [], query = '') => {
  if (!query) return [];

  return cityItems
    .filter(city => city.name.startsWith(query))
    .sort((first, second) => hebrewCollator.compare(first.name, second.name))
    .map(city => ({
      ...city,
      label: city.name,
      value: city.code,
    }));
};

export const buildStreetOptions = (streetItems = [], query = '') => {
  if (!query) return [];

  const normalizedQuery = removeGershaim(query);

  return streetItems
    .filter(street => removeGershaim(street.name).startsWith(normalizedQuery))
    .sort((first, second) => hebrewCollator.compare(first.name, second.name))
    .map(street => ({
      label: street.name,
      value: removeGershaim(street.name),
    }));
};